// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*:after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.detail-row {
  padding-left: 30px;
  display: flex;
  justify-content: space-between;
}

::ng-deep th.mat-header-cell:last-of-type,
td.mat-cell:last-of-type {
  font-weight: 400;
}

th,
label {
  font-weight: bold;
}

th {
  background-color: #f3f3f3;
  color: #696767;
  font-weight: 500 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/current-committee-officer-information/current-committee-officer-information.component.scss"],"names":[],"mappings":"AAAA;;EAGI,SAAA;EACA,UAAA;EACA,sBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,aAAA;EACA,8BAAA;AAAJ;;AAGA;;EAGI,gBAAA;AADJ;;AAIA;;EAEI,iBAAA;AADJ;;AAIA;EACI,yBAAA;EACA,cAAA;EACA,2BAAA;AADJ","sourcesContent":["*,\n*:after\n{\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n.detail-row {\n    padding-left: 30px;\n    display: flex;\n    justify-content: space-between;\n}\n\n::ng-deep th.mat-header-cell:last-of-type,\ntd.mat-cell:last-of-type\n{\n    font-weight: 400;\n}\n\nth,\nlabel {\n    font-weight: bold;\n}\n\nth {\n    background-color: #f3f3f3;\n    color: #696767;\n    font-weight: 500 !important\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
